export default "__VITE_ASSET__82593539__"